import { Box } from "@chakra-ui/react";
import Loader from "react-loader-spinner";

export const LoaderState = () => {
  return (
    <>
      <Box w="100%" h="100%" bgColor="#000" borderRadius={15} p={5}>
        <Loader type="TailSpin" color="#a2d4ec" height={50} width={50} />
      </Box>
    </>
  );
};
